const releaseEnd = {
  namespaced: true,
  state: {
    metadata: {
    }
  },
  getters: {},
  mutations: {
  },
  actions: {}
}

export default releaseEnd
